/**
 * Canonical TogetherWe legal and postal identity.
 *
 * These are deliberately NOT in the translation dictionaries. An EIN, a PO box
 * and an email address are the same string in every language, and routing them
 * through en.ts/es.ts invites a translator to "localise" them.
 *
 * They live here rather than beside their first consumer because more than one
 * surface renders them and they drifted once already: the Donate page shipped
 * `PO BOX` while the site footer shipped `PO Box` (MWBI-901). Anything that
 * renders the organization's address must import from this module so that a
 * single edit moves every surface at once.
 *
 * Consumers: `components/layout/Footer.tsx`, `app/donate/translations.ts`.
 */

export const ORG_NAME = 'TogetherWe';

export const ORG_EIN = 'EIN: 39-3429253';

export const ORG_PO_BOX = 'PO Box 766';

export const ORG_CITY_STATE_ZIP = 'Hailey, ID 83333';

export const ORG_CONTACT_EMAIL = 'info@togetherwe5b.org';

/**
 * The same details as a single sentence, for surfaces that render the address
 * inline rather than as stacked lines (the Donate page). Derived, never
 * retyped -- that is the whole point of this module.
 */
export const ORG_EIN_ADDRESS_LINE = `${ORG_EIN}, ${ORG_PO_BOX}, ${ORG_CITY_STATE_ZIP}`;
